import { isNumber } from 'lodash';

const formatSizeGb = (n?: number | null) => {
  if (!isNumber(n)) return '—';

  if (n <= 0.04) return '<0.1';

  const rounded = Math.round(n * 10) / 10;
  const hasFraction = rounded % 1 !== 0;

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: hasFraction ? 1 : 0,
    maximumFractionDigits: 1,
  });

  return formatter.format(rounded);
};

export default formatSizeGb;
